import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class InlineEditComponent extends Component
{
	@tracked isEditing = false;

	@action
	toggleEditing(event)
	{
		if(event)
		{
			event.preventDefault();
		}
		this.isEditing = !this.isEditing;
	}

	@action
	async save(event)
	{
		if(event)
		{
			event.preventDefault();
		}
		// Guard: only save once per edit session. This also prevents a double
		// save when both the form submit and a keydown handler fire on Enter.
		if(!this.isEditing)
		{
			return;
		}
		this.isEditing = false;
		try
		{
			await this.args.model.save();
		}
		catch (error)
		{
			// Error is surfaced by the adapter; just roll back the change.
			this.args.model.rollbackAttributes();
		}
	}

	@action
	cancel()
	{
		if(!this.isEditing)
		{
			return;
		}
		this.isEditing = false;
		this.args.model.rollbackAttributes();
	}

	@action
	keyDown(event)
	{
		if(event.key == "Enter" || event.keyCode == 13)
		{
			event.preventDefault();
			this.save();
		}
		else if(event.key == "Escape" || event.keyCode == 27)
		{
			this.cancel();
		}
	}
}
